import { EvaluationDetail } from './evaluationDetail';

export class Evaluation
{
    userID: number;
    evaluationID : number;
    approved : boolean;
    evaluationDetails = [];
    note;
    correctas;
    incorrectas;
    incompletas;
    promedio;
    isTest;
    constructor(){
        this.evaluationDetails = new Array<EvaluationDetail>()
    }
}